module.exports = __webpack_public_path__ + "static/media/img16.8cc9fde9.jpg";